import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      isOpen: 0,
      showCity: 0
  },
  getters: {

  },
  mutations: {
    openForm(state, value) {
      state.isOpen = value
    },
    updateCity(state, value) {
      state.showCity = value
    }
  },
  actions: {
    openContact({commit}, value) {
      commit('openForm', value)
    },
    switchCity({commit}, value) {
      commit('updateCity', value)
    }
  },
  modules: {
    
  }
})
